<roma-modal-template
  [showHeader]="false"
  [size]="'sm'"
  [contentMinHeight]="false"
  [textSuccess]="'general.confirm'"
  [headerBottomMargin]="'16px'"
  [textSuccess]="'sales.salesCard.unbindDealModalConfirm' | translate"
  [actionsAlign]="'center'"
  [responsiveFull]="false"
  (cancel)="close()"
  (success)="submit()"
>
  <div class="modal__wrapper">
    <img class="__icon" src="/assets/icons/ic_round-link-off.svg" />
    <h2>{{ 'sales.salesCard.unbindDealModalTitle' | translate }}</h2>
  </div>
</roma-modal-template>
